import React from 'react';

const CardDisplay = ({ cardType, input, name, expiry, ccv }) => {
  const cardStyles = {
    visa: {
      background: 'linear-gradient(to top, #A8C81A 0%, #D3E54B 100%)',
      logo: 'https://lalivraisonv2-api.lalivraison.ma/google_rewards/visa.png',
    },
    mastercard: {
      background: 'linear-gradient(to top, #1A75C8 0%, #6BAFF5 100%)',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg',
    },
    default: {
      background: 'linear-gradient(135deg, #000000 0%, #8B0000 33%, #FF4040 66%, #D3D3D3 100%)',
      logo: null,
    },
  };

  const currentStyle = cardType ? cardStyles[cardType] : cardStyles.default;

  return (
    <div className="cc card-display-box" style={{ background: currentStyle.background }} data-card-type={cardType}>
      <h1>LACAISSEPAY</h1>
      {currentStyle.logo && (
        <img id="card-logo" src={currentStyle.logo} alt={`${cardType} Logo`} />
      )}
      <div id="cardinfo">
        <h3>{input || 'XXXX XXXX XXXX XXXX'}</h3>
        <h3 style={{ textTransform: 'uppercase' }}>{name || 'NOM TITULAIRE'}</h3>
        <div className="row">
          <p id="expiry">{expiry || 'MM/YY'}</p>
          <p>{ccv || 'CVV'}</p>
        </div>
      </div>
    </div>
  );
};

export default CardDisplay;